export default {
    init() {
        let lea_select = document.getElementById('leas');
        let lea_print = document.getElementById('leas-print')
        if(lea_select && lea_print) {
            let options = lea_select.getElementsByTagName('option');
            console.log("The select is real!");
            for(let i = 0; i < options.length; i++) {
                console.log(options[i].value);
                let lea = document.createElement('P');
                lea.innerHTML = options[i].value;
                lea_print.appendChild(lea);
            }
        }
    }
}